import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/src/components/footer/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProtectedHeader"] */ "/app/src/components/header/protectedHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/loader/loader.tsx");
